import { render, staticRenderFns } from "./SmileyField.vue?vue&type=template&id=bcb8f076&scoped=true"
import script from "./SmileyField.vue?vue&type=script&lang=ts"
export * from "./SmileyField.vue?vue&type=script&lang=ts"
import style0 from "./SmileyField.vue?vue&type=style&index=0&id=bcb8f076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../Lasso.LassoDK/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcb8f076",
  null
  
)

export default component.exports